module.exports = __webpack_public_path__ + "static/Noon-577ae5f9526ec954f444a6292d033699.webp";